module.exports = __webpack_public_path__ + "static/media/12.f07baa4f.wav";